<template>
    <div class="products-tab" ref="products-tab">
        <products-table
                :products-data="productsData"
                :height="530"
                @change:search-products="searchProducts"
                @click:add-product="openCreateProductModal"
                @click:import-products="openImportProductsModal"
        ></products-table>
        <el-pagination
                class="pagination-footer"
                :current-page.sync="currentPage"
                :total="totalProducts"
                :page-size.sync="limit"
                :page-sizes="[10, 25, 50]"
                layout="prev, pager, next, sizes, ->, total"
        ></el-pagination>
        <import-products-modal
            :visible="showImportProductsModal"
            @close="closeImportProductsModal"
        ></import-products-modal>
        <product-modal
                :visible="showCreateProductModal"
                @close="closeCreateProductModal"
        ></product-modal>
    </div>
</template>

<script>
    import ProductModal from 'Components/ProductModal';

    import ImportProductsModal from 'Components/ImportProductsModal';

    import ProductsTable from 'Components/ProductsTable';

    import { ProductService } from "Services/ProductService";

    export default {
        components: {
            ProductsTable,
            ProductModal,
            ImportProductsModal,
        },
        data: () => ({
            search: "",
            searchTimer: null,
            showCreateProductModal: false,
            showImportProductsModal: false,
            productsData: [],
            isLoading: false,
            totalProducts: 0,
            limit: 25,
            currentPage: 1,
        }),
        mounted() {
            this.getProducts();
        },
        methods: {
            async getProducts() {
                this.isLoading = true; 
                if (this.search.length < 3) {
                    const getAllProductsResponse = await ProductService.getAllPaginated(this.limit, this.currentPage - 1);
                    this.productsData = getAllProductsResponse.data;
                    this.totalProducts = getAllProductsResponse.total;
                } else {
                    const searchProductsResponse = await ProductService.searchAll(this.search, this.limit, this.currentPage - 1);
                    this.productsData = searchProductsResponse.data;
                    this.totalProducts = searchProductsResponse.total;
                }
                this.isLoading = false;
            },
            openImportProductsModal() {
                console.log("Showing Import Products Modal");
                this.showImportProductsModal = true;
            },
            closeImportProductsModal() {
                this.showImportProductsModal = false;
            },
            openCreateProductModal() {
                console.log("Showing add products modal");
                this.showCreateProductModal = true;
            },
            closeCreateProductModal() {
                this.showCreateProductModal = false;
            },
            searchProducts(search) {
                this.search = search;
                // Make sure we only search when user stops typing for 500ms
                clearTimeout(this.searchTimer);
                this.searchTimer = setTimeout(() => {
                    this.getProducts();
                }, 500);

            },
        }
    }
</script>

<style scoped lang="scss">
    .products-tab {
        height : 100%;

        .products-tab__header {
            display       : flex;
            align-items   : center;
            margin-bottom : 15px;

            .search-bar {
                margin-right : 10px;
            }
        }
    }
</style>
